<app-modal-header [hasClose]='true' [title]="'Adicionar Perfil'" (handleClose)="close()"></app-modal-header>

@if (!loading) {
  <mat-dialog-content class="content-dialog">
    <form [formGroup]="profileForm" #formDirective="ngForm">
      <div class="options">
        <div class="form-pattern">
          <mat-form-field class="half-input">
            <mat-select matSelect formControlName="access_profile_id" placeholder="Perfis de Acesso"
              (selectionChange)="verifyRequeriments($event)">
              @for (profile of profileArray; track profile) {
                <mat-option [value]="profile.invite_profile_id">
                  {{profile.description}}
                </mat-option>
              }
            </mat-select>
            @if (profileForm.get('access_profile_id').errors && profileForm.get('access_profile_id').touched) {
              <mat-error
                >
              {{profileForm.get('access_profile_id').errors['message']}}</mat-error>
            }
          </mat-form-field>
        </div>
        @if (showSchoolInputErrorMessage()) {
          <mat-error>
            Nenhuma escola está disponível no momento para este DR.
            <br>Entre em contato com o(a) interlocutor(a).
            </mat-error>
          }
          @if (showSchoolInput()) {
            <div class="form-pattern">
              <mat-form-field class="half-input">
                <input type="text" placeholder="Escolha uma escola" aria-label="Escola" matInput
                  [formControl]="mySchoolControl" [matAutocomplete]="autoSchool">
                  <!-- <mat-select matSelect formControlName="school_id" placeholder="Escola" required (selectionChange)="filterCourse($event)"> -->
                  <mat-autocomplete #autoSchool="matAutocomplete" [displayWith]="displayFnSchool" matSelect
                    placeholder="Escolha uma escola" (optionSelected)="validControl()">
                    @for (school of filteredSchoolArray | async; track school) {
                      <mat-option [value]="school">
                        {{school.description}}
                      </mat-option>
                    }
                  </mat-autocomplete>
                <!-- </mat-select> -->
                @if (profileForm.get('school_id').errors && profileForm.get('school_id').touched) {
                  <mat-error>
                  {{profileForm.get('school_id').errors['message']}}</mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (showCourseInput()) {
            <div class="form-pattern">
              <mat-form-field class="half-input">
                <mat-select matSelect formControlName="course_id" placeholder="Curso">
                  @for (course of coursesArray; track course) {
                    <mat-option [value]="course.id">
                      {{course?.description}}
                    </mat-option>
                  }
                </mat-select>
                @if (profileForm.get('course_id').errors && profileForm.get('course_id').touched) {
                  <mat-error>
                  {{profileForm.get('course_id').errors['message']}}</mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (showCourseInputErrorMessage()) {
            <mat-error>
              Nenhum curso está disponível no momento para esta aplicação.
            </mat-error>
          }
        </div>
      </form>
    </mat-dialog-content>
  }

  <div class="modal-footer">
    <button id="modalApplyBtn" type="button" mat-raised-button color="primary"
      [disabled]="profileForm.invalid || loadingList" color="accent" (click)="addProfile()">
      Aplicar Perfil
    </button>
  </div>
